import { getBrandFromHost } from "@theme/config/theme.config";
import { getEnvironmentType } from "../utils/helpers/getEnvironmentType";
import { fgfSettings } from "@config/fgf";
import { nimbleSettings } from "@config/nimble";

const host = window.location.hostname.toLowerCase();
const brandKeyFromHost = getBrandFromHost(host);

const environmentType = getEnvironmentType(brandKeyFromHost);

const settings = environmentType === "NIM" ? nimbleSettings : fgfSettings;

const environmentSettings = {
  runConfiguration: process.env.REACT_APP_ENVIRONMENT,
  portalDebug: process.env.REACT_APP_PORTAL_DEBUG,
  cdsGlobalPrefix: process.env.REACT_APP_CDS_GLOBAL_PREFIX,
  featureEziDebit: process.env.REACT_APP_FEATURE_EZI_DEBIT,
  ...settings  
};

export default environmentSettings;